/** @typedef {typeof AccountRoutes[keyof typeof AccountRoutes]} AccountRouteSlug */

export const AccountRoutes = {
  ACCOUNT: "account",
  MY_ORDERS: "my-orders",
  MY_ADDRESS_BOOK: "myaddressbook",
  MY_ADDRESS_BOOK_EDIT: "myaddressbook-edit",
  MY_ADDRESS_BOOK_ADD: "myaddressbook-add",
  VIEW_DETAILS: "view-details",
  MESSAGE_ON_CARD: "message-on-card",
  MESSAGE_ON_CAKE: "message-on-cake",
  EDIT_SENDER_DETAILS: "edit-sender-details",
  EDIT_DELIVERY_ADDRESS: "edit-delivery-address",
  GIFT_VOUCHER: "gift-coupons",
  NOTIFICATION_SETTING: "notification-settings",
  MY_PROFILE: "profile-edit",
  ACCOUNT_HOME: "my-account",
  TRACK_ORDER: "track-order",
  SELF_HELP: "self-help",
  WALLET_DETAILS: "wallet-details",
  PARTNERS: "partners",
};

export const accountPagesTitle = {
  [AccountRoutes.MY_ADDRESS_BOOK]: "Saved addresses",
  [AccountRoutes.MY_ADDRESS_BOOK_EDIT]: "Edit address",
  [AccountRoutes.MY_ADDRESS_BOOK_ADD]: "Add a new address",
  [AccountRoutes.MY_PROFILE]: "My profile",
  [AccountRoutes.MY_ORDERS]: "My orders",
  [AccountRoutes.GIFT_VOUCHER]: "Gift vouchers",
  [AccountRoutes.VIEW_DETAILS]: "Order details",
  [AccountRoutes.TRACK_ORDER]: "Track order",
  [AccountRoutes.ACCOUNT_HOME]: "My account",
  [AccountRoutes.MESSAGE_ON_CARD]: "Message card",
  [AccountRoutes.MESSAGE_ON_CAKE]: "Edit message on cake",
  [AccountRoutes.EDIT_SENDER_DETAILS]: "Edit sender details",
  [AccountRoutes.EDIT_DELIVERY_ADDRESS]: "Edit recipient's details",
  [AccountRoutes.NOTIFICATION_SETTING]: "Notification settings",
  [AccountRoutes.WALLET_DETAILS]: "fnpCash",
  [AccountRoutes.PARTNERS]: "Partner rewards",
};

/**
 * @param {string[] | undefined} slugSegments
 * @returns {string}
 */
export function resolveAccountSectionSlug(slugSegments) {
  const first = slugSegments?.[0];
  if (!first || first === AccountRoutes.ACCOUNT_HOME) {
    return AccountRoutes.ACCOUNT_HOME;
  }
  return first;
}

/**
 * @param {string} sectionSlug
 * @returns {string}
 */
export function buildAccountPath(sectionSlug) {
  if (!sectionSlug || sectionSlug === AccountRoutes.ACCOUNT_HOME) {
    return `/account/${AccountRoutes.ACCOUNT_HOME}`;
  }
  return `/account/${sectionSlug}`;
}
